import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fontsize",
  "use": "icon-fontsize-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-fontsize\"><defs></defs><path class=\"cls-1\" d=\"M40.49455,13.49818V33.74545H74.24v80.75637H94.25455V33.74545H128V13.49818ZM0,67.2582H20.24728v47.24362H40.49455V67.2582H60.74182V47.01093H0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol